import { useContext, useEffect, useState } from "react";
import { Box } from "@remo-co/ui-core/src/components/Box";
import {
  Events,
  PAGES,
  TRACKING_CONTEXT,
  usePageTracking,
} from "modules/tracking";
import CardForm from "../../CardForm";
import { styles } from "./styles";

interface Props {
  finishOnboarding: () => void;
}

const UpdateProfileScreen = ({ finishOnboarding }: Props): JSX.Element => {
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const { track } = useContext(TRACKING_CONTEXT);

  usePageTracking(PAGES.ONBOARDING_PROFILE_UPDATE);

  useEffect(() => {
    track(Events.ATTENDEE_ONBOARDING_ADD_PROFILE_STEP);
  }, [track]);

  return (
    <Box
      sx={styles.root}
      data-testid="onboarding-screen-2"
      style={{
        justifyContent: showAdditionalFields ? "initial" : "safe center",
      }}
    >
      <CardForm
        goToNextStep={finishOnboarding}
        showAdditionalFields={showAdditionalFields}
        setShowAdditionalFields={setShowAdditionalFields}
      />
    </Box>
  );
};

export default UpdateProfileScreen;
